<style>
  .vid_side_box_inner {
  padding: 0 0 5px 0 !important;
  margin: 5px 0 0 !important;
  border-bottom: 1px solid #eee;
}
</style>
<div class="new-screen4">
  <div class="container flex flex-col">
    <h5 class="all-head">Insights</h5>
    <div class="flex display-mob max-md:!flex-col md:flex-row max-sm:!gap-[0px] max-md:!gap-[20px] md:gap-[20px]">
      <div class="max-md:!flex-[1_1_100%] md:flex-[1_1_50%] flex flex-col max-sm:!gap-[0px] max-md:!gap-[20px] md:gap-[20px]">
        <div class="flex max-sm:!flex-col sm:flex-row sm:gap-[20px]">
          @if (blogdata?.length > 0) {
            @for (item of blogdata.slice(0, 1); track item) {
              <div class="mob-brdr-btm max-sm:!flex-[1_1_100%] sm:flex-[1_1_60%]">
                <a class="testvideo" [href]="buildHrefLink(item)">
                  <div class="mrg-after-imgvid">
                    <img [appImgFallback]="item?.['image_url']" imgContext="thumb" alt="img" style="width:100%" />
                  </div>
                  <p class="internal-updates-head">{{(item['headline'] || '' ) }}</p>
                </a>
              </div>
            }
          }
          <div class="deskbg-pad max-sm:!flex-[1_1_100%] sm:flex-[1_1_40%]">
            <ul>
              @if (blogdata?.length > 1) {
                @for (item of blogdata.slice(1, 2); track item) {
                  <a class="testvideo" [href]="buildHrefLink(item)">
                    <div class="mrg-after-imgvid">
                      <img [appImgFallback]="item?.['image_url']" imgContext="thumb" alt="img" style="width:100%" />
                    </div>
                    <p class="internal-updates-head">{{(item['headline'] || '' ) }}</p>
                  </a>
                }
              }
            </ul>
          </div>
        </div>
        <div class="flex max-sm:!flex-col sm:flex-row sm:gap-[20px]">
          <div class="deskbg-pad max-sm:!flex-[1_1_100%] sm:flex-[1_1_40%]">
            <ul>
              @if (blogdata.length > 2) {
                <a class="testvideo" [href]="buildHrefLink(blogdata[2])">
                  <div class="mrg-after-imgvid">
                    <img [appImgFallback]="blogdata[2]?.['image_url']" imgContext="thumb" alt="img" style="width:100%" />
                  </div>
                  <p class="internal-updates-head">{{ blogdata[2]?.headline || '' }}</p>
                </a>
              }

            </ul>
          </div>
          @if (blogdata.length > 3) {
            <div class="mob-brdr-btm max-sm:!flex-[1_1_100%] sm:flex-[1_1_60%]">
              <a class="testvideo" [href]="buildHrefLink(blogdata[3])">
                <div class="mrg-after-imgvid">
                  <img [appImgFallback]="blogdata[3]?.['image_url']" imgContext="thumb" alt="img" style="width:100%" />
                </div>
              </a>
              <p class="internal-updates-head">{{ blogdata[3]?.headline || '' }}</p>
            </div>
          }

        </div>
      </div>

      <div class="max-md:!flex-[1_1_100%] md:flex-[1_1_50%]">
        <div class="flex max-sm:!flex-col sm:flex-row sm:gap-[20px]">
          <div class="max-sm:!flex-[1_1_100%] md:flex-[1_1_50%]">
            <ul>
              @if (blogdata?.length > 4) {
                @for (item of blogdata.slice(4, 10); track item) {
                  <a class="testvideo" [href]="buildHrefLink(item)">
                    <li>
                      <div class="brdr-btm flex flex-col">
                        <p class="internal-updates-head">{{ item.headline || '' }}</p>
                      </div>
                    </li>
                  </a>
                }
              }

            </ul>
          </div>
          <div class="max-sm:!flex-[1_1_100%] md:flex-[1_1_50%] flex flex-col">
            @if (blogdata?.length > 10) {
              <div class="brdr-btm">
                <a class="testvideo" [href]="buildHrefLink(blogdata[10])">
                  <div class="mrg-after-imgvid">
                    <img [appImgFallback]="blogdata[10]?.['image_url']" imgContext="thumb" alt="img" style="width:100%" />
                  </div>
                  <p class="internal-updates-head">{{ blogdata[10]?.headline || '' }}</p>
                </a>
              </div>
            }

            @if (blogdata?.length > 11) {
              <div class="brdr-btm">
                <a class="testvideo" [href]="buildHrefLink(blogdata[11])">
                  <div class="mrg-after-imgvid">
                    <img [appImgFallback]="blogdata[11]?.['image_url']" imgContext="thumb" alt="img" style="width:100%" />
                  </div>
                  <p class="internal-updates-head">{{ blogdata[11]?.headline || '' }}</p>
                </a>
              </div>
            }

          </div>
        </div>
      </div>
    </div>
    <a class="testvideo" href="/insights"> <button mat-flat-button class="view-all-btn">View all</button></a>
  </div>
</div>